import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch, reactive, onMounted } from 'vue';


interface Props {
  modelValue?: boolean | null
  placeholder?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownSimNao',
  props: {
    modelValue: { type: [Boolean, null] },
    placeholder: {}
  },
  emits: ['update:modelValue', 'selected'],
  setup(__props: any, { emit: __emit }) {

var props = __props;
const emit = __emit

var controle = reactive({
  valor: props.modelValue,
  text: "",
  status: ""
})

function selecionar() {
    emit('update:modelValue', controle.valor);
    emit('selected', controle.valor)
}


watch<boolean | undefined>(() => props.modelValue, (newValue) => {
  controle.valor = newValue ?? false;
})


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).valor) = $event)),
    class: "form-select form-select-sm",
    onChange: _cache[1] || (_cache[1] = ($event: any) => (selecionar()))
  }, [...(_cache[2] || (_cache[2] = [
    _createElementVNode("option", { value: null }, "- Selecione -", -1),
    _createElementVNode("option", { value: true }, "Sim", -1),
    _createElementVNode("option", { value: false }, "Não", -1)
  ]))], 544)), [
    [_vModelSelect, _unref(controle).valor]
  ])
}
}

})